import React, { Component } from 'react';
import tradeshow_management_photo from './photo_tradeshow_management.jpg';
import exhibit_management_photo from './photo_exhibit_management.jpg';
import design_photo from './photo_design.jpg';
import displays_photo from './photo_displays.jpg';
import custom_fabrication_photo from './photo_custom_fabrication.jpg';
import accessories_photo from './photo_accessories.jpg';
import contact_photo from './photo_contact.jpg';
import environment_photo from './photo_environment.jpg';

class SideImage extends Component {

getImage(page){
    switch(page){
        case "TradeshowManagement":
            return tradeshow_management_photo;
        case "ExhibitManagement":
            return exhibit_management_photo;
        case "Displays":
            return displays_photo;
        case "CustomFabrication":
            return custom_fabrication_photo;
        case "Accessories":
            return accessories_photo;
        case "Design":
            return design_photo;
        case "Contact":
            return contact_photo;
        case "Thankyou":
            return contact_photo;
        case "Environment":
            return environment_photo;
        default:
            return tradeshow_management_photo;
    }
}

  render() {
    return (
        <div className="sideImage hidden-xs">
            <img src={this.getImage(this.props.page)} alt=""/>
        </div>
    );
  }
}

export default SideImage;






// WEBPACK FOOTER //
// ./src/components/SideImage/SideImage.js